import React from 'react'
import styled from '@emotion/styled'
import { BaseRadioInput } from '../ui/form/BaseRadioInput'

export type CareRadioButtonProps = {
  option: { label: string; value: string; hint: string }
  checked: boolean
  onChange: React.ChangeEventHandler<HTMLInputElement>
}

export const CareRadioButton = ({
  option,
  checked,
  onChange,
}: CareRadioButtonProps) => (
  <RadioButton key={option.value}>
    <RadioInput
      type='radio'
      id={option.value}
      value={option.value}
      name='care'
      checked={checked}
      onChange={onChange}
    />
    <label htmlFor={option.value}>
      <OptionLabel>{option.label}</OptionLabel>
      <OptionHint>{option.hint}</OptionHint>
    </label>
  </RadioButton>
)

const RadioInput = styled(BaseRadioInput)`
  margin-right: 15px;
`

export const RadioButton = styled.div`
  display: flex;
  margin-bottom: 15px;
  align-items: center;
`

export const OptionHint = styled.div`
  font-size: 0.85rem;
`

export const OptionLabel = styled.span`
  display: block;
  font-weight: 600;
  margin-bottom: 2px;
`
